<script lang="ts">
  import { breakpoints as br } from "$lib/utils/getBreakpoints";
  import SanityPicture from "$lib/SanityPicture.svelte";
  import type { AlternativeVariant } from "$lib/types/products";

  interface Props {
    variants?: AlternativeVariant[] | undefined;
    sizes?: string;
    class?: string;
  }

  let {
    variants = [],
    sizes = `(min-width: ${br.desktop}) 20vw, (min-width: ${br.laptop}) 25vw, 45vw`,
    class: classes = "",
  }: Props = $props();
  let sortedVariant = $derived(
    variants?.sort((a, b) => (a.sortString > b.sortString ? 1 : -1)) || []
  );
</script>

<div class={classes}>
  <p class="mb-0 text-$fg-muted text-center"><small>Produktvarianter</small></p>
  <p
    class="my-0 text-sm flex flex-wrap gap-x-2 items-stretch justify-center children-w-[min(50%,10rem)]"
  >
    {#each sortedVariant || [] as variant (variant.slug)}
      {@const current = !!variant.current}
      {#if variant.firstImage}
        <a
          class:current
          class="button button-link flex flex-col p-0"
          href={`/nettbutikk/${variant.slug}`}
        >
          <span class:opacity-0={current} class="font-400">{variant.title}</span>
          <SanityPicture
            alt={variant.title + " – " + variant.sortString}
            class="order--1 aspect-video object-contain block p-2 mt-5"
            pictureObject={variant.firstImage}
            {sizes}
          />
        </a>
      {/if}
    {/each}
  </p>
</div>

<style lang="postcss">
  a {
    & :global(img) {
      transition: filter 0.1s var(--easing);
      box-shadow:
        0 -3px var(--skodde),
        inset 0 1px var(--glod);
    }
  }

  a.current {
    cursor: default;

    & :global(img) {
      box-shadow: inset 0 3px var(--primary-strong);
    }
  }

  a:hover {
    text-decoration: underline;
  }

  a:focus-visible :global(img) {
    box-shadow: 0 0 0 3px var(--primary-strong);
  }
</style>
